export default {
    en: {
        login:{
            username: 'Username',
            password: 'Password',
            remember: 'Remember me',
            no_sites: 'User has no shops',
            forgot_password: 'Forgot password?',
            logged_in: 'You have successfully logged in',
            select_site: 'Please select a shop',
            buttons:{
                log_in: 'Sign In',
            }
        },
        search: 'Search',
        edit: 'Edit',
        logout: 'Logout',
        welcome: 'Welcome',
        minutes: 'minutes',
        seconds: 'seconds',
        continue: 'Continue',
        to_logout: 'Time to automatic logout',
        messages: {
            idle_notice: 'You have been idle for a while. Do you want to stay logged in?',
        },
        buttons: {
            print: 'Print',
            save: 'Save',
            confirm: 'Confirm',
            annul: 'Annul',
            filters: 'Filters',
            submit_filter:'Submit filter',
            clear_filter:'Clear filter',
            close:'Close',
            back: 'X',
            new: 'Add',
            upload: 'Upload'
        },
        created: 'Created:',
        updated: 'Updated:',
        confirmed:'Confirmed:',
        annulled:'Annulled:',
        annulment_reason:'Annulment reason:',
        actions: 'Actions',
        yes:'Yes',
        no:'No'
    },
    et: {
        login:{
            username: 'Kasutajanimi',
            password: 'Parool',
            remember: 'Mäleta mind',
            no_sites: 'Kasutajal puuduvad õigused. Palun püürdu Helpdeski poole ligipääsu tellimiseks ',
            forgot_password: 'Unustasid parooli?',
            logged_in: 'Sisenemine edukas!',
            select_site: 'Palun vali pood',
            buttons:{
                log_in: 'Sisene',
            }
        },
        search: 'Otsi',
        edit: 'Ava',
        logout: 'Välju',
        welcome: 'Tere tulemast!',
        minutes: 'minutit',
        seconds: 'sekundit',
        continue:'Jätka tööd',
        to_logout:'Aega automaatse väljumiseni:',
        messages: {
            idle_notice: 'Süsteem on olnud pikemalt tegevuseta. Kas soovid jätkata?',
            no_permission: 'Õigused puuduvad'
        },
        buttons: {
            print: 'Prindi',
            save: 'Salvesta',
            confirm: 'Kinnita',
            annul: 'Tühista',
            filters: 'Filtrid',
            submit_filter:'Rakenda',
            clear_filter:'Tühjenda',
            close:'Sulge',
            back: 'X',
            new: 'Uus',
            create:'Loo',
            allow_all: 'Luba kõik',
            deny_all:'Keela kõik',
            open_accordion:'Ava/Sule kõik moodulid',
            delete: 'Kustuta',
            upload: 'Laadi üles'
        },
        filters:{
           'open': 'Avatud',
           'confirmed': 'Kinnitatud',
           'annulled': 'Tühitatud'
        },
        created: 'Loodud:',
        updated: 'Uuendatud:',
        confirmed:'Kinnitatud:',
        annulled:'Tühistatud:',
        annulment_reason:'Tühistamise põhjus:',
        actions: 'Toimingud',
        yes:'Jah',
        no:'Ei',
        action: 'Toimingud',
    }
}